__webpack_require__.p = "/marketing-campaigns/sweepstakes/static/";